/**
 * L'adresse de contact publiée.
 *
 * ── Pourquoi ici, et à un seul endroit ──────────────────────────────────────
 * Elle apparaît à quatre endroits : les mentions légales, les conditions
 * générales, la page « Données personnelles » et le formulaire de contact. Une
 * adresse recopiée quatre fois est une adresse qui, au premier changement,
 * n'est plus juste qu'à trois endroits — et l'on ne s'en aperçoit que le jour
 * où quelqu'un écrit dans le vide.
 *
 * ── Ce que la loi impose ────────────────────────────────────────────────────
 * La LCEN exige la publication d'un moyen de contact DIRECT dans les mentions
 * légales. Un formulaire seul n'y suffit pas : il faut une adresse écrite,
 * lisible, que l'on peut recopier dans son propre logiciel de messagerie. Le
 * formulaire vient en plus, pour ceux qui n'ont pas de messagerie sous la main.
 *
 * Tant que cette constante vaut `null`, les pages affichent la mention
 * « À COMPLÉTER » plutôt qu'une adresse inventée.
 *
 * ── ⚠ VALEUR PROVISOIRE ─────────────────────────────────────────────────────
 * `example.com` est un domaine RÉSERVÉ par l'IANA (RFC 2606) : il n'appartient
 * à personne et n'aboutit nulle part. C'est délibéré — une adresse fantaisiste
 * sur un vrai domaine finirait dans la boîte d'un inconnu, qui recevrait les
 * réclamations de vos clients.
 *
 * Elle rend donc les pages présentables, et elle NE FONCTIONNE PAS. À remplacer
 * avant la première vente : le formulaire de contact, lui, marche déjà.
 */
export const ADRESSE_CONTACT: string | null = 'contact@example.com';

/**
 * L'adresse publiée aboutit-elle quelque part ?
 *
 * ── Le défaut que cela ferme ────────────────────────────────────────────────
 * Quand l'envoi du formulaire échouait, la page disait « écrivez directement à
 * l'adresse indiquée plus bas ». Or cette adresse est, pour l'instant, un
 * domaine RÉSERVÉ qui n'aboutit nulle part : on renvoyait vers le vide
 * quelqu'un dont le seul autre chemin venait de se refermer.
 *
 * Le contrôle se fait sur les domaines réservés par la RFC 2606 plutôt que sur
 * un drapeau à lever à la main : le jour où l'adresse devient réelle, elle est
 * proposée d'elle-même, sans qu'on ait à se souvenir d'un second réglage.
 */
export const ADRESSE_CONTACT_ABOUTIT = ADRESSE_CONTACT !== null
  && !/@example\.(com|org|net)$/i.test(ADRESSE_CONTACT);
